import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { StateService } from '../../services/state.service';
import { ToolService } from '../../public-api';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private state: StateService,
    private router: Router,
    private tools: ToolService
  ) {}

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    console.log('Auth Guard here. Heading to ' + state.url);
    let storageToken = await this.state.readFromSecureStorage(
      this.state.ACCESSTOKENKEY
    );
    let storageTokenEnd = await this.state.readFromSecureStorage(
      this.state.ACCESSTOKENLIFETIMEENDKEY
    );

    let tokenValid = false;
    if (
      new Date(storageTokenEnd).getTime() - this.state.refreshBuffer >
      Date.now()
    )
      tokenValid = true;
    if (this.state.accessToken != null && tokenValid) {
      console.log('Auth Guard: Nice, state token present and valid');
      return true;
    }

    if (tokenValid) {
      console.log('Auth Guard: Nice, storage token still valid');
      this.state.accessTokenLifetimeEnd = new Date(storageTokenEnd);
      this.state.accessToken = storageToken;
      this.state.init();
      return true;
    } else {
      console.log('Auth Guard: Token outdated');
    }
    try {
      await this.state.ensureTokenIsValid();
    } catch (err) {
      await this.tools.showErrorToast(err as string);
    }
    return (
      this.state.accessToken != null &&
      this.state.accessTokenLifetimeEnd != null &&
      this.state.accessTokenLifetimeEnd.getTime() > Date.now()
    );
  }
}
